/**
 * Returns '#000000' or '#FFFFFF' based on background brightness
 */
export function getContrastColor(hexColor) {
    if (!hexColor || hexColor === 'transparent') return '#000000';
    
    const cleanHex = hexColor.replace('#', '');
    const fullHex = cleanHex.length === 3 
        ? cleanHex.split('').map(char => char + char).join('')
        : cleanHex;

    const r = parseInt(fullHex.substring(0, 2), 16);
    const g = parseInt(fullHex.substring(2, 4), 16);
    const b = parseInt(fullHex.substring(4, 6), 16);
    
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    
    return yiq >= 128 ? '#000000' : '#FFFFFF';
}
